import styled from 'styled-components';
import breakpoints from '@designSystem/breakpoints';
import { ReactComponent as LogoOnlyIcon } from '@assets/images/logo-only.svg';
import { ReactComponent as MainLogoIcon } from '@assets/images/logo.svg';

export const StyledMainLogo = styled(MainLogoIcon)`
  @media (max-width: ${breakpoints.large}) {
    display: none;
  }
`;

export const StyledLogoOnly = styled(LogoOnlyIcon)`
  display: none;
  @media (max-width: ${breakpoints.large}) {
    display: block;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0px;
`;

export const FlexItemGrow = styled.div`
  flex-grow: 1;

  @media (max-width: ${breakpoints.large}) {
    flex-grow: 0;
  }
`;

interface LinkI {
  disabled?: boolean;
}

export const Link = styled.a<LinkI>`
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;
